<template>
    <div class="addPackege h-100">
        <div class="row justify-content-center align-items-center h-100">
            <loader v-if="pageLoader"></loader>
            <div class="col-12 col-md-6">
                <div class="bg-white border-radius-5 p-4 addPackege h-100">
                    <img src="../../../../static/website/images/changePass.svg" alt="Image">
                    <div class="form-group iconInput">
                        <div class="position-relative">
                            <input :type="showOldPass?'text':'password'" placeholder="Enter old password" name="old Password" v-model="oldPass" class="float-field form-control" v-validate="'required'">
                            <a href="javascript:void(0)" @click="showOldPass = !showOldPass" class="icon"><feather :type="showOldPass?'eye':'eye-off'" class="toggle-password"></feather></a>
                        </div>
                        <p class="error" v-if="submitted" v-for="error in errors.collect('old Password')">{{ error }}</p>
                    </div>
                    <div class="form-group iconInput">
                        <div class="position-relative">
                           <input :type="showNewPass?'text':'password'" placeholder="Enter new password" name="new password" v-model="newPass" class="float-field form-control" v-validate="{ required: true, regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*/])\S{6,24}$/}" ref="password">
                           <a href="javascript:void(0)" @click="showNewPass = !showNewPass" class="icon"><feather :type="showNewPass?'eye':'eye-off'" class="toggle-password"></feather></a>
                       </div>
                        <p class="error" v-if="submitted" v-for="error in errors.collect('new password')">{{ error }}</p>
                    </div>
                    <div class="form-group iconInput">
                        <div class="position-relative">
                           <input :type="showConfirmPass?'text':'password'" placeholder="Confirm new password" name="confirm password" v-model="confirmPass" class="float-field form-control" v-validate="'required|confirmed:password'">
                           <a href="javascript:void(0)" @click="showConfirmPass = !showConfirmPass" class="icon"><feather :type="showConfirmPass?'eye':'eye-off'" class="toggle-password"></feather></a>
                       </div>
                        <p class="error" v-if="submitted" v-for="error in errors.collect('confirm password')">{{ error }}</p>
                    </div>
                    <div class="col-12 mt-4">
                        <div class="form-group text-center mb-0">
                            <a href="javascript:void(0)" class="btn btn-link btn-blue" @click="changePassword()">Submit</a><br>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapActions } from 'vuex'
    import * as types from '@/types'
    export default {
        name: "Change-Password",
        data() {
            return {
                pageLoader: false,
                oldPass : '',
                showOldPass : false,
                newPass : '',
                showNewPass : false,
                confirmPass : '',
                showConfirmPass : false,
                submitted : false,
            }
        },
        methods:{
           ...mapActions({
                _runChangePassword: types.RUN_CHANGE_PASSWORD,
                _runLogout: types.RUN_LOGOUT
            }),
            reset(){
                this.oldPass = ''
                this.newPass = ''
                this.confirmPass = ''
                this.submitted = false
                this.showOldPass= 'password'
                this.showNewPass= 'password'
                this.showConfirmPass= 'password'
            },
            changePassword(){
                const _that = this
                _that.submitted = true;
                _that.$validator.validate().then(valid => {
                    if (valid) {
                        let input_json={
                            'globalParams' :{
                                'oldpassword' : _that.oldPass ,
                                'password' : _that.newPass
                            },
                            'localParams' :{ "parameter" : _that }
                        }
                        _that._runChangePassword(input_json)
                    }
                });
            },
            logout(){
                let input_json={
                    'globalParams' :{},
                    'localParams' :{ "parameter" : this }
                }
                this._runLogout(input_json)
            }
           
        },
        created(){
            this.pageName('Change Password')
        }

    }
</script>


// WEBPACK FOOTER //
// src/components/website/user/change_password.vue